module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG4562632520a33289a2a20a5b365ef6b5.45626325.png";